export const resolveLookupParams = () => {
  const params = new URLSearchParams(window.location.search || '');
  const email = params.get('email');
  const orderNumber = params.get('order') || params.get('orderNumber');

  if (!email || !orderNumber) {
    return null;
  }

  return { email, orderNumber };
};

